import type { JarvisState } from "../types";

interface MicButtonProps {
  state: JarvisState;
  onPress: () => void;
}

function Icon({ state }: { state: JarvisState }) {
  if (state === "listening") {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="#4fd7ff" strokeWidth="2">
        <rect x="6" y="6" width="12" height="12" rx="2" />
      </svg>
    );
  }
  if (state === "speaking") {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="#4fd7ff" strokeWidth="2">
        <rect x="7" y="6" width="3" height="12" rx="1" />
        <rect x="14" y="6" width="3" height="12" rx="1" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" strokeLinecap="round" />
      <path d="M12 18v3" strokeLinecap="round" />
    </svg>
  );
}

const LABELS: Record<JarvisState, string> = {
  idle: "Spustiť hlasovú konverzáciu",
  listening: "Zastaviť nahrávanie a odoslať",
  thinking: "Jarvis premýšľa",
  speaking: "Zastaviť prehrávanie",
  error: "Skúsiť znova",
};

export function MicButton({ state, onPress }: MicButtonProps) {
  return (
    <button
      type="button"
      className={`mic-button state-${state}`}
      onClick={onPress}
      disabled={state === "thinking"}
      aria-label={LABELS[state]}
    >
      <Icon state={state} />
    </button>
  );
}
